import { BankAccountDeliveryMethod } from '@melio/platform-api';

export const isPlaidAccount = (bankAccountDetails: BankAccountDeliveryMethod | undefined) =>
  !!bankAccountDetails?.details.plaidAccount?.accountId;
